import api from './api'
const unwrap = async (promise) => (await promise).data.data
export default {
  catalog: () => unwrap(api.get('/crm/field-sales/catalog')),
  list: (params = {}) => api.get('/crm/field-orders', { params }).then((res) => res.data),
  get: (id) => unwrap(api.get(`/crm/field-orders/${id}`)),
  save: (accountId, body) => unwrap(api.post(`/crm/${accountId}/field-orders`, body)),
  confirm: (id, body) => unwrap(api.post(`/crm/field-orders/${id}/confirm`, body)),
  schedule: (id, body) => unwrap(api.post(`/crm/field-orders/${id}/schedule`, body)),
  deliver: (id, body) => unwrap(api.post(`/crm/field-orders/${id}/deliver`, body)),
  calendar: (kind, id) => unwrap(api.get('/crm/calendar-invite', { params: { kind, id } }))
}
export const orderLabel = (order) => order.status === 'cancelled' ? 'Cancelled' : order.status === 'draft' ? 'Draft' : order.fulfillment === 'delivered' ? 'Delivered' : order.fulfillment === 'partially_delivered' ? 'Partly delivered' : order.deliveryDate ? 'Drop-off scheduled' : 'Needs drop-off'
export const money = (amount) => amount == null ? 'Price needed' : new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Number(amount))
